import { EsBadge } from './ui'

/**
 * Shared risk scale legend for Early Signals supplier-score tabs.
 * Normalized scale 1–10 with Low / Medium / High bands.
 * Shown on Intelligence View and Risk Overview.
 */
export function RiskScaleLegend() {
  return (
    <div className="mb-4 space-y-2" role="doc" aria-label="Risk rating scale legend">
      <div className="flex flex-wrap items-center gap-3 py-2 text-sm">
        <EsBadge tone="quiet" className="!text-xs !px-3 !py-1">
          Normalized Scale: 1–10
        </EsBadge>
        <span className="text-es-hairline" aria-hidden>
          |
        </span>
        <span className="text-xs text-es-muted font-medium uppercase tracking-wider">Risk rating:</span>
        <EsBadge tone="riskLow" className="!text-xs !px-2.5 !py-0.5 !rounded-full">
          Low (1.0–4.0)
        </EsBadge>
        <EsBadge tone="riskMedium" className="!text-xs !px-2.5 !py-0.5 !rounded-full">
          Medium (4.1–6.0)
        </EsBadge>
        <EsBadge tone="riskHigh" className="!text-xs !px-2.5 !py-0.5 !rounded-full">
          High (above 6.0)
        </EsBadge>
      </div>
      <p className="text-xs text-es-muted max-w-4xl">
        Overall score comes from the Master file. Low is 1.0–4.0, Medium is 4.1–6.0, High is above 6.0.
        AVG is the mean of scored unique suppliers. Count on category, region, and location is unique
        suppliers; count on brand is supplier–brand lines. Hover Count | % for definitions. In % mode,
        band KPIs sum to 100%; rollup High % is within that group.
      </p>
    </div>
  )
}
